export default __webpack_public_path__ + "static/media/nap-time.5c513871f7f023d49094c6c01b17c544.jpg";